"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModalHeader = exports.StyledModalFooter = exports.StyledModal = exports.ModalWrapper = exports.ModalOverlay = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = _interopRequireDefault(require("../../shared/theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const smallCss = (0, _styledComponents.css)(["width:444px;"]);
const mediumCss = (0, _styledComponents.css)(["width:779px;"]);
const largeCss = (0, _styledComponents.css)(["width:1219px;"]);
const maxSizeMap = new Map();
maxSizeMap.set('small', smallCss);
maxSizeMap.set('medium', mediumCss);
maxSizeMap.set('large', largeCss);
const ModalOverlay = (0, _styledComponents.default)('div').withConfig({
  displayName: "styles__ModalOverlay",
  componentId: "sc-itlcd5-0"
})(["position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#121213;opacity:0.75;"]);
exports.ModalOverlay = ModalOverlay;
const StyledModalHeader = (0, _styledComponents.default)('div').withConfig({
  displayName: "styles__StyledModalHeader",
  componentId: "sc-itlcd5-1"
})(["display:flex;justify-content:space-between;", ";margin-bottom:3rem;button{margin-right:5px;margin-left:5px;}.header-text{", ";}.buttons-section{display:flex;}"], _theme.default.typography.caption, _theme.default.typography.body);
exports.StyledModalHeader = StyledModalHeader;
const StyledModalFooter = (0, _styledComponents.default)('div').withConfig({
  displayName: "styles__StyledModalFooter",
  componentId: "sc-itlcd5-2"
})(["display:flex;justify-content:flex-end;", ";margin-top:3rem;button{margin-right:5px;margin-left:5px;}"], _theme.default.typography.caption);
exports.StyledModalFooter = StyledModalFooter;
const ModalWrapper = (0, _styledComponents.default)('div').withConfig({
  displayName: "styles__ModalWrapper",
  componentId: "sc-itlcd5-3"
})(["position:fixed;top:0;left:0;z-index:1050;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0;font-family:", ";.content-wrapper{}.cross-btn{position:absolute;top:23px;right:23px;", ";display:flex;padding-right:3.125px;justify-content:flex-end;}.modal{z-index:100;background:white;position:relative;margin:1.75rem auto;border-radius:0.1875rem;", ";}.modal-header{display:flex;justify-content:flex-end;}.modal-close-button{display:inline-flex;align-items:center;margin-right:8px;border:none;}button{display:block;padding:0.5rem 1.25rem;font-size:0.875rem;}.modal-titel{font-size:1.125rem;}.modal-body{font-size:0.8125rem;margin-top:1.3125rem;}"], _theme.default.typography.caption.fontFamily, ({
  size
}) => maxSizeMap.get(`${size}`), ({
  size
}) => maxSizeMap.get(`${size}`));
exports.ModalWrapper = ModalWrapper;

const StyledModal = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledModal",
  componentId: "sc-itlcd5-4"
})(["position:fixed;z-index:", ";left:0;top:0;bottom:0;right:0;width:100%;height:100%;background:rgba(18,18,19,0.75);display:flex;justify-content:center;align-items:center;.modal_content{box-sizing:border-box;border-radius:6px;position:relative;background:", ";color:", ";padding:", ";", ";min-height:24px;z-index:", ";.close-container{cursor:pointer;position:absolute;top:20px;right:24px;}}"], _theme.default.zIndex.hoverOver, _theme.default.palette.brand.primary.white, _theme.default.palette.brand.primary.charcoal, ({
  padding
}) => `${padding}`, ({
  size,
  width,
  height
}) => size ? maxSizeMap.get(`${size}`) : `width: ${width}; height: ${height}`, _theme.default.zIndex.modal);

exports.StyledModal = StyledModal;